import { render, staticRenderFns } from "./ScalesSettings.vue?vue&type=template&id=6c72150b&scoped=true"
import script from "./ScalesSettings.vue?vue&type=script&lang=js"
export * from "./ScalesSettings.vue?vue&type=script&lang=js"
import style0 from "./ScalesSettings.vue?vue&type=style&index=0&id=6c72150b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c72150b",
  null
  
)

export default component.exports